import { NetworkErrorCode, WsNetworkError } from '@gem/modules/wsClient/wsErrors';
import { WsDisconnectCode, WsController, WsNetworkService } from '@gem/modules/wsClient/wsServices';

export class WsAppApiController {
  private token: string;
  private ws: WsController;
  private refreshTokenFn: (() => Promise<string | null>) | null = null;

  constructor(private networkService: WsNetworkService, private url: string) {
    this.ws = new WsController(networkService);
    this.ws.onClose((event: CloseEvent) => this.handleWsClose(event));
  }

  public connect(token: string, url: string, withoutPingPong?: boolean): void {
    this.url = url;
    this.token = token;
    this.ws.connect(`${this.url}/connect?token=${this.token}`, 'arraybuffer', withoutPingPong);
  }

  public set refreshToken(refreshTokenFn: () => Promise<string | null>) {
    this.refreshTokenFn = refreshTokenFn;
  }

  public disconnect(message = 'Unauthorized'): void {
    const error = new WsNetworkError(NetworkErrorCode.Unauthorized, message);
    this.networkService.error(error);
    this.ws.disconnect();
  }

  private async handleWsClose(event: CloseEvent): Promise<void> {
    if (event.code === 4401) {
      const token = this.refreshTokenFn ? await this.refreshTokenFn() : null;

      if (token) {
        this.connect(token, this.url);
      } else {
        this.disconnect(event.reason);
      }
    }
    if (event.code === WsDisconnectCode.UnexpectedError) {
      this.connect(this.token, this.url);
    }
  }
}
